var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('home.noItem'))+"～")])])}
var staticRenderFns = []

export { render, staticRenderFns }